import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=513da47f&scoped=true"
import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=513da47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513da47f",
  null
  
)

export default component.exports